module.exports = __webpack_public_path__ + "static/media/holmes.f55556ca.png";